import axios from 'axios'

const DEFAULT_API_PORT = 10088

// Cached promise so concurrent / repeat callers share a single initialization.
let initApiBaseURLPromise = null

const urlStore = {
  state: {
    url: process.env.VUE_APP_API_URL || (window.location.protocol + '//' + window.location.hostname + ':' + DEFAULT_API_PORT),
    urlOverride:null,
    apiBaseURLInitialized: false,
    overrideConfig: null,
  },
  actions: {
    setURL (context, url) {
      context.commit('setURL', url)
    },
    setURLOverride (context, url) {
      context.commit('setURLOverride', url)
    },
    /**
     * Resolve the API base URL override from environment / config.json.
     * Idempotent: subsequent calls return the same in-flight or completed promise.
     * Resolves to the parsed override config object (or null).
     */
    initApiBaseURL (context) {
      if (initApiBaseURLPromise) {
        return initApiBaseURLPromise
      }
      initApiBaseURLPromise = (async () => {
        if (process.env.VUE_APP_AUTOMATED_API_ROUTING
            && process.env.VUE_APP_AUTOMATED_API_ROUTING_SUFFIX
            && process.env.VUE_APP_AUTOMATED_API_ROUTING_PREFIX) {
          context.commit('setURLOverride',
            process.env.VUE_APP_AUTOMATED_API_ROUTING_PREFIX
            + window.location.host.split('.')[0]
            + process.env.VUE_APP_AUTOMATED_API_ROUTING_SUFFIX)
          context.commit('setApiBaseURLInitialized', true)
          return null
        }
        let overrideConf = null
        try {
          const configOverride = await axios.get('/config.json')
          if (configOverride && configOverride.data) {
            overrideConf = configOverride.data
            if ((typeof overrideConf === 'string' || overrideConf instanceof String)
                && overrideConf.startsWith('{')) {
              overrideConf = JSON.parse(overrideConf)
            }
            if (overrideConf[window.location.host] && overrideConf[window.location.host].API_BASE_URL) {
              context.commit('setURLOverride', overrideConf[window.location.host].API_BASE_URL)
            } else if (overrideConf['*'] && overrideConf['*'].API_BASE_URL) {
              context.commit('setURLOverride', overrideConf['*'].API_BASE_URL)
            }
            context.commit('setOverrideConfig', overrideConf)
          }
        } catch (err) {
          // Reset so a transient failure can be retried on the next call
          // instead of being stuck with the cached null result for the session.
          initApiBaseURLPromise = null
          console.log('No config override found')
        } finally {
          context.commit('setApiBaseURLInitialized', true)
        }
        return overrideConf
      })()
      return initApiBaseURLPromise
    },
  },
  mutations: {
    setURL (state, url) {
      state.url = url
      localStorage.setItem('url', url)
      // add to localstorage
    },
    setURLOverride (state, url) {
      state.urlOverride = url
    },
    setApiBaseURLInitialized (state, val) {
      state.apiBaseURLInitialized = val
    },
    setOverrideConfig (state, conf) {
      state.overrideConfig = conf
    }
  },
  getters: {
    apiBaseURL(state) {
      if(localStorage.getItem('url')){
        return localStorage.getItem('url')
      } else if(state.urlOverride){
        return state.urlOverride
      } else {
        return state.url
      }
    }
  }
}

export default urlStore
